import dotenv from "dotenv";
dotenv.config();

export const config = {
    adentis: {
        host: process.env.REACT_APP_MICROSOFT_ADENTIS_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_ADENTIS_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_ADENTIS_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_ADENTIS_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_ADENTIS_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_ADENTIS_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_ADENTIS_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_ADENTIS_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_ADENTIS_ISSUER,
        }
    },
    agap2: {
        host: process.env.REACT_APP_MICROSOFT_AGAP2_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_AGAP2_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_AGAP2_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_AGAP2_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_AGAP2_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_AGAP2_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_AGAP2_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_AGAP2_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_AGAP2_ISSUER,
        }
    },
    bee: {
        host: process.env.REACT_APP_MICROSOFT_BEE_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_BEE_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_BEE_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_BEE_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_BEE_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_BEE_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_BEE_ISSUER,
        }
    },
    codewin: {
        host: process.env.REACT_APP_MICROSOFT_CODEWIN_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_CODEWIN_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_CODEWIN_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_CODEWIN_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_CODEWIN_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_CODEWIN_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_CODEWIN_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_CODEWIN_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_CODEWIN_ISSUER,
        }
    },
    teamit: {
        host: process.env.REACT_APP_MICROSOFT_TEAMIT_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_TEAMIT_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_TEAMIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_TEAMIT_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_TEAMIT_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_TEAMIT_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_TEAMIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_TEAMIT_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_TEAMIT_ISSUER,
        }
    },
    recodme: {
        host: process.env.REACT_APP_MICROSOFT_RECODME_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_RECODME_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_RECODME_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_RECODME_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_RECODME_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_RECODME_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_RECODME_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_RECODME_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_RECODME_ISSUER,
        }
    },
    kcsit: {
        host: process.env.REACT_APP_MICROSOFT_KCSIT_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_KCSIT_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_KCSIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_KCSIT_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_KCSIT_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_KCSIT_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_KCSIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_KCSIT_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_KCSIT_ISSUER,
        }
    },
    loginPage: process.env.REACT_APP_LOGIN_PAGE,
    enable: process.env.REACT_APP_LOGIN_PAGE_ENABLE
};
